export const TYPEACTIONCACHE = {
    GET: 'get',
    SET: 'set',
    DELETE: 'delete'
};
